import React from "react";

import { numToSSColumn, alphabetArray } from "../../helpers/utils";

export const answerFormat = (question) => {
  if (
    // (question && question.question_type) === "sa" ||
    // (question && question.question_type) === "la"
    question &&
    typeof question.answers[0].content === "string"
  ) {
    return (question && question.answers.map((item, index) => {

        return (item.correct === true ?
          <p style={{ fontWeight: 'bold' }}>{`${alphabetArray[index]} ${item.content} `}</p> 
          :
          <p>{`${alphabetArray[index]} ${item.content}`}</p>)
    //return <p>{parse((question && question.answers[0].content) || "")}</p>;

  }))} else if (
    question &&
    typeof question.answers[0].content === "object" &&
    typeof question.answers[0].content.true === "boolean"
  ) {
    return (
      <>
        <p> {`${numToSSColumn(1)}. ${question.answers[0].content.true}`} </p>
        <p>{`${numToSSColumn(2)}. ${question.answers[0].content.false}`} </p>
      </>
    );
  } else {
    const options = question && Object.entries(question.answers[0].content);
    return (
      <>
        {options &&
          options.map((el) => {
            return (
              <p>{`${numToSSColumn(parseInt(el[0]) + 1)}. ${el[1].value}`} </p>
            );
          })}
      </>
    );
  }
};
